<template>
  <article class="wrap-view-more">
    <button
      class="flat with-border"
      :style="`
        width: 100%;
        height: 100%;
        --button-font-weight: var(--font-weight-normal);
        --button-background: transparent;
        --button-hover-background: var(--fa-navy);
        --button-hover-color: var(--white);
        --button-margin-bottom: 0`"
      @click="$emit('viewMore', { family: selectedFamily, style: selectedStyle })"
    >
      <span class="margin-right-2xs">{{ currentLabel }}</span>
      <span>
        <font-awesome-icon
          :icon="$v6.solid.faArrowRight"
          fixed-width
          size="lg"
        />
      </span>
    </button>
  </article>
</template>

<script>
  export default {
    name: 'ViewMore',

    props: {
      selectedFamily: {
        type: String,
        required: true
      },
      selectedStyle: {
        type: String
      },
      hasSearchTerm: {
        type: Boolean
      }
    },

    computed: {
      currentLabel() {
        return this.hasSearchTerm ? 'More results' : 'View more'
      }
    }
  }
</script>
